import { useState } from 'react';
import { FAQSchema } from '@/components/base/SchemaOrg';

const faqData = [
  {
    question: '八戒影院的影视资源更新速度快吗？',
    answer: '八戒影院拥有专业的资源运营团队，热播剧和新片上线后第一时间同步更新，确保用户能够抢鲜观看。热门剧集一般在播出后2小时内即可上线，电影资源也会在上映后尽快更新高清版本。',
  },
  {
    question: '八戒影院的播放画质如何？',
    answer: '八戒影院提供多种清晰度选择，包括高清720P、超清1080P和蓝光4K画质。平台采用先进的视频压缩和CDN加速技术，确保高清画质的同时也能流畅播放，不卡顿不缓冲。',
  },
  {
    question: '在八戒影院观看影视需要付费吗？',
    answer: '八戒影院的绝大部分影视内容都是免费提供给用户观看的，无需注册登录即可在线播放。我们通过广告收入来维持平台运营，致力于为用户提供免费的优质观影体验。',
  },
  {
    question: '八戒影院支持哪些设备观看？',
    answer: '八戒影院全面支持PC电脑、平板、手机等多种设备观看。网站采用响应式设计，在不同屏幕尺寸下都能获得良好的观影体验。同时支持主流浏览器如Chrome、Safari、Edge等。',
  },
  {
    question: '如果在八戒影院遇到播放问题怎么办？',
    answer: '如遇到播放卡顿、无法加载等问题，建议您尝试以下方法：1）切换播放线路；2）降低清晰度；3）刷新页面；4）更换浏览器。如问题依然存在，可通过「联系我们」页面联系客服获取帮助。',
  },
  {
    question: '八戒影院的资源库有多大？',
    answer: '八戒影院目前拥有超过12万部影视资源，涵盖电影、电视剧、动漫、综艺、纪录片、少儿等全品类内容。资源库每日持续扩充，覆盖国产、日韩、欧美等全球热门影视作品，满足不同用户的观影需求。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <>
      <FAQSchema questions={faqData} />
      <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 text-center mb-8">
            常见问题
          </h2>
          <div className="flex flex-col gap-3">
            {faqData.map((item, index) => (
              <div
                key={index}
                className="rounded-lg bg-background-50 border border-background-300/40 overflow-hidden"
              >
                <button
                  onClick={() => toggle(index)}
                  className="w-full flex items-center justify-between px-5 py-4 text-left text-sm font-medium text-foreground-800 hover:text-primary-400 transition-colors"
                >
                  <span>{item.question}</span>
                  <i
                    className={`ri-arrow-down-s-line text-lg transition-transform duration-200 ${
                      openIndex === index ? 'rotate-180' : ''
                    }`}
                  />
                </button>
                {openIndex === index && (
                  <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                    {item.answer}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}